import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  viberTemplates:state => state.viberTemplates,
  viberMultichannelTemplates:state => state.viberMultichannelTemplates,
  viberTemplateItem:state => state.viberTemplateItem,
};